import { SchedaWeeks } from "./SchedaWeeks";

/**
 * The top of the Scheda landing: the origin of the name, and the product's own picture of
 * a week. The page has no hero; this band opens it, with a little more air than a mid-page
 * band (see `#origin` in landing-redesign.css).
 *
 * <p>This carries the page's only {@code h1}. If the story ever moves without taking the
 * h1 with it, the landing ships with no h1 at all. It is sized like an h2 on purpose: the
 * approved design opens quietly, but the semantics stay.
 *
 * <p>It is a {@code div} inside the band's {@code section}, as it always was. The grounds
 * are explicit band classes now, so the section count is no longer load-bearing, but the
 * guard in {@code marketing.test.tsx} keeps the structure honest.
 *
 * <p>The autumn-metal redesign (2026-10, signed-off preview) set this band in Inter
 * Display like the rest of the page; the Cormorant/EB Garamond serif the earlier design
 * used here left with it. The copy — the story, the kicker, the dropped initial — is
 * unchanged.
 *
 * <p>One action, not two: "try" and "log in" both led to the same door, so the band keeps
 * a single Log in. The prop type still accepts {@code onTry} so call sites and tests need
 * not churn; it is deliberately unused.
 */
export function SchedaOrigin({ onLogIn }: { onTry: () => void; onLogIn: () => void }) {
  return (
    <div id="origin" className="origin">
      <div className="wrap split">
        <div>
          <p className="eyebrow float">Origin</p>
          <h1 className="float">From a slip of paper to your whole week</h1>
          <p className="story float d1">
            <span className="drop">S</span>
            <span className="opener">cheda takes its name</span> from <em>schid&#275;</em>, the
            ancient Greek word for a slip of paper: a strip torn from something larger and kept
            because it carried a time, a name, or a promise. For centuries that was the whole
            technology of keeping track. A pocket of scraps, each one a fragment of a day.
          </p>
          <p className="kicker float d2">Turn your daily hustle into effortless structure.</p>
          <div className="ctas float d2">
            <button type="button" className="btn cta" onClick={onLogIn}>
              Log in
            </button>
          </div>
        </div>

        <div className="glass float d1">
          <SchedaWeeks />
        </div>
      </div>
    </div>
  );
}
